const ArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.17248 5.25728L6.67248 5.25728L6.67248 6.25728L7.17248 6.25728L13.0354 6.25728L5.40419 13.8885L5.05064 14.242L5.75775 14.9492L6.1113 14.5956L13.7435 6.96335L13.7435 12.8284L13.7435 13.3284L14.7435 13.3284L14.7435 12.8284L14.7435 5.75728C14.7435 5.48114 14.5197 5.25728 14.2435 5.25728L7.17248 5.25728Z"
      fill="currentColor"
    />
  </svg>
);

export { ArrowIcon };
